import { Box, Center, ButtonGroup } from "@chakra-ui/react"
import React from "reactn"
import { Layout } from "./layoutEmpty"
import { navigate } from 'gatsby';
import API from '@aws-amplify/api';
import { string, object } from "yup";
import { Formik, Form } from 'formik';
import './contact.css';

import {
    InputControl,
    ResetButton,
    SubmitButton,
    TextareaControl,
} from "formik-chakra-ui";


const onSubmit = (values, { setSubmitting, resetForm, setStatus }) => {
    if (values.email2) {
        resetForm()
    } else {
        const subject = "CONTACT SUBJECT"
        const fields = {
            "name": values.namesjdj,
            "email": values.emailjajs,
            "content": values.contentaskds,
            "subject": subject
        }

        const data = {
            body: fields,
            headers: {
                "Content-Type": "application/json"
            }
        };
        API
            .post('api', '/email/send', data)
            .then(response => {
                setSubmitting(false);
                navigate('/success/');
            })
            .catch(error => {
                setStatus("ERROR SUBMITTING FORM")
                setSubmitting(false);
            });
    }
}

const validationSchema = object({
    namesjdj: string().required("Name is required."),
    contentaskds: string().required("eMail address is required."),
    emailjajs: string().email().required("Message is required."),
});

const ContactForm = () => {
    return (
        <Center >
            <Box w={['80%', '80%', '50%', '50%']} id="contactForm">
                <Formik
                    initialValues={{
                        namesjdj: "",
                        contentaskds: "",
                        emailjajs: ""
                    }}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}

                >
                    {({ handleSubmit, status }) => (
                        <Form
                            borderWidth="1px"
                            maxWidth={800}
                            p={6}
                            m="10px auto"
                            as="form"
                            onSubmit={handleSubmit}
                        >
                            <InputControl name="namesjdj" id="namesjdj" label="NAME" borderRadius={0} />
                            <InputControl type="email" name="emailjajs" id="emailjajs" label="EMAIL" borderRadius={0} />
                            <TextareaControl name="contentaskds" id="contentaskds" label="MESSAGE" borderRadius={0} />
                            {!!status && <Box color="red">{status}</Box>}
                            <Center>
                                <ButtonGroup mt={5}>
                                    <SubmitButton variant={'contact'}>Submit</SubmitButton>
                                    <ResetButton variant={'contact'}>Reset</ResetButton>
                                </ButtonGroup>
                            </Center>

                        </Form>

                    )}
                </Formik>
            </Box>
        </Center>

    )
}

ContactForm.Layout = Layout

export default ContactForm

